// extracted by mini-css-extract-plugin
export default {"root":"ThemeToggle_root__JuS+2","thumb":"ThemeToggle_thumb__FYTP6"};